<template>
  <div class="content-wrap" :style="getContentWrapStyle()">
    <BaseSearchbar
      v-if="toolbar"
      ref="toolbar"
      v-model="searchData"
      v-bind="toolbar"
    ></BaseSearchbar>
    <BasePath
      v-if="basepath"
      ref="basepath"
      v-model="basepath.value"
      v-bind="basepath.bind"
      v-on="basepath.on"
    ></BasePath>
    <div class="table-wrap" :style="getTableWrapStyle()">
      <el-table
        v-if="tableShow"
        :data="rows"
        height="100%"
        v-loading="loading"
        element-loading-text="拼命加载中"
        v-loadmore="loadmore"
      >
        <el-table-column
          v-for="(col, index) in columns"
          :key="index"
          v-bind="col.bind"
          show-overflow-tooltip
        >
          <template #header="scope">
            <component
              v-if="col.header && col.header.component"
              :is="$getComponent(col.header.component, scope)"
              v-bind="col.header.bind"
              v-on="col.header.on"
              :scope="scope"
            ></component>
            <span v-else>{{ scope.column.label }}</span>
          </template>
          <template #default="scope">
            <component
              v-if="col.default && col.default.component"
              :is="$getComponent(col.default.component, scope)"
              v-bind="col.default.bind"
              v-on="col.default.on"
              :scope="scope"
            ></component>
            <span v-else v-text="defaultCell(scope, col.format)"></span>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div v-if="showPagination" class="pagination">
      <el-pagination
        style="text-align: right"
        @size-change="sizeChange"
        @current-change="currentChange"
        :current-page="query.pageIndex"
        :page-sizes="[10, 20, 30, 40, 50, 60, 70, 80, 90, 100]"
        :page-size="query.pageSize"
        layout="total, sizes, prev, jumper, next"
        :total="total"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
// import BaseSearchbar from './BaseSearchbar.vue'
// import BasePath from './BasePath.vue'
export default {
  name: 'cus-base-table',
  props: {
    toolbar: Object,
    basepath: Object,
    url: String,
    delUrl: String,
    downUrl: String,
    columns: Array,
    rules: Array,
    initSearch: {
      //初始化后执行查询操作
      type: Boolean,
      default: true,
    },
    showRefreshBtn: {
      //是否显示刷新按钮 默认显示
      type: Boolean,
      default: true,
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
  },
  components: {
    // BaseSearchbar,
    // BasePath
  },
  directives: {
    loadmore: {
      // 指令的定义
      bind: function (el, binding, vnode) {
        var selectWrap = el.querySelector('.el-table__body-wrapper')
        vnode.context.loadmore_delay = true
        selectWrap.addEventListener('scroll', function () {
          var sign = 100
          var scrollDistance =
            this.scrollHeight - this.scrollTop - this.clientHeight
          if (vnode.context.loadmore_delay && scrollDistance <= sign) {
            vnode.context.loadmore_delay = false
            new Promise(binding.value).then(function () {
              vnode.context.loadmore_delay = true
            })
            //binding.value()
            // console.log('距离底部小于100了')
            // console.log(vnode.context)
            // // 指令中不能用this关键字
            // vnode.context.getNewData()
          }
        })
      },
    },
  },
  created() {
    var that = this

    if (!this.toolbar.buttons) {
      this.toolbar.buttons = [
        {
          label: '查询',
          on: { click: this.tableSearch },
          bind: { icon: 'el-icon-search', type: 'primary' },
        },
        {
          label: '重置',
          on: { click: this.tableSearchReset },
          bind: { icon: 'el-icon-refresh-left' },
        },
      ]
      if (this.downUrl) {
        this.toolbar.buttons.push({
          label: '导出',
          on: { click: this.downLoadData },
          bind: { icon: 'el-icon-download' },
        })
      }

      //额外的button
      if (Array.isArray(this.toolbar.exButtons)) {
        for (var i = 0; i < this.toolbar.exButtons.length; i++) {
          this.toolbar.buttons.push(this.toolbar.exButtons[i])
        }
        console.log(this.toolbar.buttons)
        //this.toolbar.buttons=this.toolbar.buttons.concat(this.toolbar.exButtons);
      }
    }

    if (that.showRefreshBtn) {
      that.toolbar.buttons.push({
        label: '刷新',
        bind: {
          icon: 'el-icon-refresh',
          type: 'primary',
          style: 'position: absolute;right: 50px;',
          value: 'refresh',
        },
        on: { click: that.refreshBtn },
      })
    }

    if (this.toolbar.query) {
      //Object.assign(this.query, this.toolbar.query);
      if (!this.toolbar.query.pageIndex) this.toolbar.query.pageIndex = 1
      if (!this.toolbar.query.pageSize) this.toolbar.query.pageSize = 30
      this.query = this.toolbar.query
    }

    if (that.initSearch) {
      setTimeout(() => {
        that.refreshData()
      }, 50)
    }
  },
  data() {
    return {
      loading: false,
      rows: [],
      total: 0,
      searchData: {},
      seData: {},
      tableShow: true,
      query: {
        pageIndex: 1,
        pageSize: 30,
      },
    }
  },
  methods: {
    //刷新按钮事件
    refreshBtn() {
      var that = this
      that.$refs.toolbar.$refs.form.resetFields() //重置查询条件
      that.tableShow = false //刷新表格
      that.$nextTick(function () {
        that.tableShow = true
        that.$nextTick(function () {
          that.tableSearch()
        })
      })
    },
    getTableWrapStyle() {
      var style = {}
      if (this.basepath) {
        style.height = 'calc(100% - 14px)'
      }
      return style
    },
    getContentWrapStyle() {
      var style = {}
      if (!this.showPagination) {
        style.paddingBottom = '10px'
      }
      return style
    },
    defaultCell(scope, format) {
      var that = this
      if (format && typeof format == 'function') {
        return format(scope.row[scope.column.property])
      } else {
        return scope.row[scope.column.property]
      }
    },
    /*查询按钮事件*/
    tableSearch() {
      this.query.pageIndex = 1
      this.refreshData()
    },
    /*重置查询条件*/
    tableSearchReset() {
      this.$refs.toolbar.resetForm()
    },
    /*获取查询参数*/
    getSearchData() {
      var data = Object.assign({}, this.searchData, this.query)
      return data
    },
    /*刷新table数据*/
    refreshData() {
      var that = this
      var data = that.getSearchData()
      var url = that.url + that.query.pageIndex + '/' + that.query.pageSize
      axios
        .post(url, data)
        .then(function (response) {
          if (response.data.code == 0) {
            that.rows = response.data.data.Data || []
            that.total = response.data.data.Total || 0
          } else {
            alert(response.data.msg)
          }
        })
        .catch(function (error) {
          alert('请求发生错误！')
          console.log(error)
        })
      // console.log(data)
      // that.$postObj(that.url, data, (data, headers) => {
      // 	that.loading = true;
      // 	console.log(headers)
      // 	headers.post['Content-Type'] = 'application/json'
      // }, function (data) { that.loading = false; })
      // .then(resp=>{
      // 	if(resp.data.code==0){
      // 		that.rows = resp.data.data.Data || [];
      // 		that.total = resp.data.data.Total || 0;
      // 	}else{
      // 		alert(resp.data.msg);
      // 	}
      // })
      // .catch(error => { // 请求失败处理
      // 	alert('请求发生错误！');
      // 	console.error(error);
      // });
    },
    sizeChange(pageSize) {
      this.query.pageIndex = 1
      this.query.pageSize = pageSize
      this.refreshData()
    },
    currentChange(pageIndex) {
      this.query.pageIndex = pageIndex
      this.refreshData()
    },
    loadRows(rows) {
      this.rows = rows
    },
    delRow(row) {
      var that = this
      var index = that.rows.indexOf(row)
      if (index > -1) that.rows.splice(index, 1)
    },
    addRow(row) {
      this.rows.unshift(row)
    },
    updRow(oldRow, newRow) {
      for (var key in oldRow) {
        this.$set(oldRow, key, newRow[key])
      }
    },
    loadmore(resolve, reject) {
      this.$emit('on-loadmore', resolve, reject)
    },
    /**
     * 导出数据
     */
    dataURLtoFile(dataurl) {
      // 生成Blob
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new Blob([u8arr], { type: mime })
    },
    createDownloadFileUrl(miniType, base64) {
      const blob = this.dataURLtoFile(`data:${miniType};base64,${base64}`)
      blob.lastModifiedDate = new Date()
      return URL.createObjectURL(blob)
    },
    downLoadData() {
      var searchData = this.getSearchData()
      if (!searchData.startTime) {
        this.$message('请选择开始时间')
        return
      }
      if (!searchData.endTime) {
        this.$message('请选择结束时间')
        return
      }
      this.$postObj(this.downUrl, searchData)
        .then((resp) => {
          if (resp.data.code == 0) {
            //var b = new Blob([11111], { type: 'application/vnd.ms-excel' })
            var url = this.createDownloadFileUrl(
              'application/vnd.ms-excel',
              resp.data.data
            )
            var link = document.createElement('a')
            // 设置导出的文件名
            link.download =
              'advance反馈数据_' +
              searchData.startTime +
              '至' +
              searchData.endTime +
              '.xls'
            link.href = url
            link.click()
          } else {
            this.$message(resp.data.msg)
          }
        })
        .catch((error) => {
          // 请求失败处理
          console.error(error)
          this.$message('请求发生错误！' + error.toString())
        })
    },
  },
}
</script>

<style>
.content-wrap {
  padding: 62px 10px 52px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  background-color: #fff;
  /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.2);
	border-radius: 2px;
	overflow: hidden; */
}

.table-wrap {
  height: 100%;
}
.pagination {
  position: absolute;
  left: 10px;
  right: 10px;
  bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// packages/BaseTable.vue